import dayjs from 'dayjs'
import React from 'react'
import 'dayjs/locale/id'

import WebinarCard, {
  WebinarPreloader,
} from '../../partials/Webinar/WebinarCard'
import GenericList from 'app/PelatihanMandiriPage/components/GenericList'
import InfoBox from './InfoBox'
import { useSETrackerEvent } from 'app/PelatihanMandiriPage/hooks/useSETrackEvent'

import type { WebinarEntry } from 'api/microlearning/types'

type TopicWebinarProps = {
  items: WebinarEntry[]
  isLoading: boolean
  isError: boolean
}

const TopicWebinar = ({ items, isLoading, isError }: TopicWebinarProps) => {
  const { SETrackWebinar } = useSETrackerEvent()

  const WEBINAR_THRESHOLD_DEADLINE_MINUTES = 30
  const wibTime = dayjs().tz('Asia/Jakarta')
  const webinarDataFiltered: WebinarEntry[] = !isLoading
    ? items.filter(({ endDate }) =>
        wibTime.isBefore(
          dayjs(endDate).add(WEBINAR_THRESHOLD_DEADLINE_MINUTES, 'minute')
        )
      )
    : []

  const fetchState = isLoading ? 'loading' : 'success'

  const handleTracker = (title: string) => {
    SETrackWebinar({
      action_type: 'click_webinar',
      action_value: title,
    })
  }

  return (
    <div>
      <div className="flex items-start mb-2">
        <div className="flex items-center">
          <img
            src="https://storage.googleapis.com/microlearning-public-production/web-assets/webinar-icon.png"
            height={24}
            width={24}
            alt="Webinar"
          />
        </div>
        <div className="flex-1 ml-2">
          <div className="font-semibold text-lg">
            Webinar
            {webinarDataFiltered.length
              ? ` (${webinarDataFiltered.length})`
              : ''}
          </div>
        </div>
      </div>
      <GenericList
        key="webinar"
        data={webinarDataFiltered}
        dataState={fetchState}
        listKey={({ id }) => id}
        loadingComponent={<WebinarPreloader />}
        renderItem={({ id, title, speakers, startDate, endDate, module }) => {
          const topicData = module[0]

          return (
            <div className="mb-2" onClick={() => handleTracker(title)}>
              <WebinarCard
                id={id}
                href={`/${
                  process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
                  'pelatihan-mandiri'
                }/webinar/${id}`}
                topicId={`${topicData?.topikId}`}
                topicName={topicData?.topikTitle}
                title={title}
                speakers={speakers}
                startDate={startDate}
                endDate={endDate}
                isShowNameSpeakers={false}
              />
            </div>
          )
        }}
        emptyComponent={
          <InfoBox
            title={
              !isError
                ? 'Belum ada jadwal webinar terbaru'
                : 'Terjadi masalah dalam memuat webinar'
            }
            description={
              !isError
                ? 'Jadwal webinar yang tersedia akan tampil disini'
                : 'Silakan coba lagi dalam beberapa saat.'
            }
            isError={isError}
            isShowButton={false}
          />
        }
      />
    </div>
  )
}

export default TopicWebinar
